import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const CannedHome = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/snippet'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'canned_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'canned_list',
          meta: {
            featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
            flushSettingsContent: true,
          },
          component: CannedHome,
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/canned-response/:page(list)?'
      ),
      redirect: to => ({
        name: 'canned_list',
        params: { accountId: to.params.accountId },
        query: to.query,
        hash: to.hash,
      }),
    },
  ],
};
